module.exports = "/images/testimonials-icon.png?8d6bfd484bf8e989afc79f016fc3b26d";